// Первым импортом и ничем иным: он ставит Buffer, без которого библиотеки
// TON падают прямо на загрузке модуля. Подробности — в самом файле.
import './lib/buffer-first.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { App } from './App.tsx';
import { initI18n } from './lib/i18n.ts';
import { captureReferralCode, initTelegram } from './lib/telegram.ts';
import { reportReferralVisit } from './lib/referral.ts';
import { initTheme } from './lib/theme.ts';
import './styles.css';

initTelegram();
// Приглашение приходит только в момент открытия по ссылке — запоминаем сразу,
// до всякой отрисовки: до покупки человек успеет уйти и вернуться.
captureReferralCode();
// Переход отмечается сразу: человек может посмотреть и уйти, не подключая
// кошелёк, и без этой отметки приглашающий видел бы «приглашено 0», не
// понимая, ссылка не работает или просто ещё никто не купил.
void reportReferralVisit();
initI18n();
initTheme();

const manifestUrl =
  import.meta.env['VITE_TONCONNECT_MANIFEST'] ?? `${window.location.origin}/tonconnect-manifest.json`;

// Данные сделок меняются медленно — они пишутся блокчейном, а не пользователем.
// Частый перезапрос только жёг бы лимиты RPC на стороне индексера.
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: false } },
});

/**
 * Заставку снимаем после первого кадра, а не по таймеру: по таймеру она
 * либо мигает на быстром устройстве, либо уходит раньше готовности на
 * медленном.
 */
function hideSplash(): void {
  const splash = document.getElementById('splash');
  if (splash === null) return;
  splash.classList.add('gone');
  // Останавливаем смену шагов: таймер живёт в разметке и о React не знает.
  window.dispatchEvent(new Event('splash-done'));
  setTimeout(() => splash.remove(), 300);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TonConnectUIProvider manifestUrl={manifestUrl}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </TonConnectUIProvider>
  </StrictMode>,
);

requestAnimationFrame(hideSplash);
